module.exports = __webpack_public_path__ + "static/sketches-978c818e038dedd32254c1ac0d71fa25.png";